import { GET_TUTOR_LIST, GET_TUTOR_DETAIL, PUT_TUTOR_EDIT, POST_TUTOR_CREATE, DELETE_TUTOR} from "./TutorAction";

let initialState = {
    getTutorList:           false,
    errorTutorList:         false,
    getTutorDetail:         false,
    errorTutorDetail:       false,
    getResponDataTutor:     false,
    errorResponDataTutor:   false,
    getResponDataTutorC:    false,
    errorResponDataTutorC:  false,
    getTutorBorrar:         false,
    errorTutorBorrar:       false,
};

const TutorReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_TUTOR_LIST:
            return {
                ...state,
                getTutorList: action.payload.data,
                errorTutorList: action.payload.errorMessage,
            };

        case GET_TUTOR_DETAIL:

            return {
                ...state,
                getTutorDetail: action.payload.data,
                errorTutorDetail: action.payload.errorMessage,
            };

        case PUT_TUTOR_EDIT:
            return {
                ...state,
                getResponDataTutor: action.payload.data,
                errorResponDataTutor: action.payload.errorMessage,
            };

        case POST_TUTOR_CREATE:
            return {
                ...state,
                getResponDataTutorC: action.payload.data,
                errorResponDataTutorC: action.payload.errorMessage,
            };

        case DELETE_TUTOR:
            return {
                ...state,
                getTutorBorrar: action.payload.data,
                errorTutorBorrar: action.payload.errorMessage,
            };
            

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default TutorReducer;